export const PET_ANIM_PREFIX = "pet-";
export const PET_SHEET_TEXTURE = "pet-spritesheet";

export {
  PET_ATTACK_RANGE,
  PET_DEPTH_BEHIND,
  PET_FOLLOW_LERP,
  PET_FOLLOW_OFFSET_X,
  PET_FOLLOW_OFFSET_Y,
  PET_SKILL_RANGE,
} from "@/pet/constants";
